'use client';

import { ChevronDown, ChevronUp } from 'lucide-react';
import { StockItem } from '../data-market-table/types';
import { useTranslations } from '@/lib/locale-context';

export default function SmiHeader({
  lastPrice,
  dayChangePercent,
  dayChangePrice,
}: Pick<StockItem, 'dayChangePercent' | 'lastPrice' | 'dayChangePrice'>) {
  const { t } = useTranslations();

  const isNegative =
    typeof dayChangePercent === 'number' && dayChangePercent < 0;
  const textColorClass = isNegative ? 'text-[#E8464C]' : 'text-[#77B900]';
  const Icon = isNegative ? ChevronDown : ChevronUp;

  // Format currentValue: e.g., 13'033 CHF
  const formattedCurrentValue =
    typeof lastPrice === 'number'
      ? new Intl.NumberFormat('de-CH', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(lastPrice) + ' CHF'
      : '–';

  // Format percentageChange: e.g., -0.49% or +0.49%
  const formattedPercentageChange =
    typeof dayChangePercent === 'number'
      ? `${dayChangePercent >= 0 ? '+' : ''}${dayChangePercent.toFixed(2)}%`
      : '–';

  // Format formattedPriceChange: e.g., (-62.20) or (+62.20)
  const formattedPriceChange =
    typeof dayChangePrice === 'number'
      ? `(${dayChangePrice >= 0 ? '+' : ''}${dayChangePrice.toFixed(2)})`
      : '';

  return (
    <div className="w-full rounded-[12px] border border-neutral-100 bg-brand-100 px-[18px] py-[20px]">
      <h2 className="text-[20px] font-[400] text-[#2C2C2C]">
        {t('markets.smiTitle')}
      </h2>
      <div className="flex items-center gap-[10px]">
        <section className="mr-[10%] flex items-center gap-1">
          <Icon className={`h-5 w-5 ${textColorClass} fill-current`} />
          <span className="text-[18px] font-[400] text-black">
            {formattedCurrentValue ? formattedCurrentValue : '-'}
          </span>
        </section>
        <span className={`text-[14px] font-[400] ${textColorClass}`}>
          {formattedPercentageChange ? formattedPercentageChange : '-'}
        </span>
        <span className="text-[14px] font-[400] text-neutral-900">
          {formattedPriceChange ? formattedPriceChange : '-'}
        </span>
      </div>
    </div>
  );
}
